import { combinePathRoutes } from "src/helpers"
import routes from "src/routes"
import { lazy } from "react"
import { CREATE, LIST, SEARCH, UPDATE, VIEW, VIEW_ABSENT_ANTIRABIQUE,PROTOCOL_ANTIRABIQUE, CREATE_NEXT } from "src/constants"
import { ANTIRABIQUE, CHILDREN, DASHBOARD, INTERNATIONAL, OCCASIONAL, ROUTINE, SEASONAL, VACCINATION, SCOLAIRE } from "src/constants/AppPermissions"
import { CitizenManagement, VaccinationManagement } from "src/constants/ModulesPermissions"
import { components } from "react-select/dist/react-select.cjs.prod"




const VaccinationFolders = lazy(() => import("./../VaccinationFolder"))
const VaccinationOccationalFolders = lazy(() => import("./../VaccinationOccationalFolder"))
const VaccinationSaisonFolders = lazy(() => import("./../VaccinationSaisonFolder"))

const VaccinationSearch = lazy(() => import("../components/card/VaccinationSearch"))
const VaccinationOccasionals = lazy(() => import("../components/card/VaccinationOccasionalSearch"))
const VaccinationNewEdit = lazy(() => import("../components/card/VaccinationNewEdit"))
const VacationOccasionalNewEdit = lazy(() => import("../components/card/OccationalVaccinationsNewEdit"))

const VaccinationNext = lazy(() => import("../components/card/VaccinationNext"))

const VaccinationHomePage = lazy(() => import("./../VaccinationHomePage"))


const VaccinationSeasonsSearch = lazy(() => import("./../components/card/VaccinationSaisonSearch"))
const VaccinationSeasonNewEdit = lazy(() => import("./../components/card/SeasonVaccinationsNewEdit"))

const VaccinationAntirabiesSearchComponent = lazy(() => import("./../components/card/VaccinationAntirabiesSearch"))
const VaccinationficheAntirabiesFolders = lazy(() => import("./../VaccinationFicheAntirabiesFolder"))
const VacationAntirabiesNewEdit = lazy(() => import("../components/card/VaccinationAntirabiesNewEdit"))
//const vaccinationAntirabiesSchema = lazy(() => import("../components/card/VaccinationAntirabiesSchemas"))
const VaccinationAntirabiesKPI = lazy(() => import("../components/card/VaccinationAntirabiesKpi"))



//International Vaccination
const VaccinationInternationalFolders = lazy(() => import("./../VaccinationInternationalFolder"))
const VaccinationInternationalSearch = lazy(() => import("./../components/card/VaccinationInternationalSearch"))
const VaccinationInternationalNew = lazy(() => import("../components/card/VaccinationInternationalNew"))
const VaccinationInternationalEdit = lazy(() => import("../components/card/VaccinationInternationalEdit"))

// Scolaire Vaccination
const VaccinationScolaireFolders = lazy(() => import("./../VaccinationScolaireFolder"))
export const vaccinationCreate = {
  path: "/vaccine/routine-vaccination/new/:param",
  component: VaccinationNewEdit,
  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE][ROUTINE]
}

export const nextvaccination = {
  path: "/vaccine/routine-vaccination/nex/:param",
  component: VaccinationNext,
  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE_NEXT][ROUTINE]
}



export const vaccinationOccationalCreate = {
  path: "/vaccine/occasional-vaccination/new/:param",
  component: VacationOccasionalNewEdit,
  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE][OCCASIONAL]
}



export const vaccinationSeasonCreate = {
  path: "/vaccine/season-vaccination/new/:param",
  component: VaccinationSeasonNewEdit,
  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE][SEASONAL]
}


export const vaccinationOccasionals = {
  path: "/vaccine/occasional-vaccination",
  component: VaccinationOccasionals,
  exact:true,

  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE][OCCASIONAL]
}

export const VaccinationSeasonSearch = {
  path: "/vaccine/season-vaccination",
  component: VaccinationSeasonsSearch,
  exact:true,

  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE][SEASONAL]
}

export const vaccinationFolder = {
  path: "/vaccine/routine-vaccination/vaccinationFolder/:param([0-9]{9})",
  component: VaccinationFolders,
  can: VaccinationManagement.module[VACCINATION].permissions[VIEW][ROUTINE]
}
export const vaccinationOccationalFolder = {
  path: "/vaccine/occasional-vaccination/:param([0-9]{9})",
  component: VaccinationOccationalFolders,
  can: VaccinationManagement.module[VACCINATION].permissions[VIEW][OCCASIONAL]
}

export const VaccinationSaisonFolder = {
  path: "/vaccine/season-vaccination/:param([0-9]{9})",
  component: VaccinationSaisonFolders,
  can: VaccinationManagement.module[VACCINATION].permissions[VIEW][SEASONAL]
}


export const vaccinationList = {
  path: "/vaccine/routine-vaccination",
  component: VaccinationSearch,
  exact:true,
  can: CitizenManagement.module[CHILDREN].permissions[SEARCH]

}

export const vaccination = {
  path: "/vaccine",
  component:VaccinationHomePage,
  exact:true
}

/* Antirabies vaccination routes */
export const VaccinationAntirabiesSearch = {
  path: "/vaccine/antirabique-vaccination",
  component: VaccinationAntirabiesSearchComponent,
  exact:true,

  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE][ANTIRABIQUE]
}


/* export const VaccinationAntirabiesSchemas = {
  path: "/vaccine/antirabique-vaccination/schema",
  component: vaccinationAntirabiesSchema,
  exact:true,

  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE]
}
 */

export const vaccinationAntirabiesFolder = {
  path: "/vaccine/antirabique-vaccination/:param([0-9]{9})",
  component: VaccinationficheAntirabiesFolders,
  can: VaccinationManagement.module[VACCINATION].permissions[VIEW][ANTIRABIQUE]
}

export const vaccinationAntirabiesCreate = {
  path: "/vaccine/antirabique-vaccination/new/:param",
  component: VacationAntirabiesNewEdit,
  can:  VaccinationManagement.module[VACCINATION].permissions[CREATE][ANTIRABIQUE]
}

export const vaccinationAntirabiesEdit = {
  path: "/vaccine/antirabique-vaccination/edit/:param",
  component: VacationAntirabiesNewEdit,
  can:  VaccinationManagement.module[VACCINATION].permissions[UPDATE][ANTIRABIQUE]
  //can:  VaccinationManagement.module[VACCINATION].permissions[UPDATE][[PROTOCOL_ANTIRABIQUE]]
}
export const vaccinationAntirabiesFirstEdit = {
  path: "/vaccine/antirabique-vaccination/update/:param",
  component: VacationAntirabiesNewEdit,
  //can:  VaccinationManagement.module[VACCINATION].permissions[UPDATE][ANTIRABIQUE]
  can:  VaccinationManagement.module[VACCINATION].permissions[UPDATE][[PROTOCOL_ANTIRABIQUE]]
}
export const vaccinationAntirabiesView = {
  path: "/vaccine/antirabique-vaccination/details/:param",
  component: VacationAntirabiesNewEdit,
  can:  VaccinationManagement.module[VACCINATION].permissions[VIEW][ANTIRABIQUE]}


export const vaccinationAntirabiesKPI = {
  path: "/vaccine-antirabique",
  component: VaccinationAntirabiesKPI,
  can: VaccinationManagement.module[DASHBOARD].permissions[VIEW_ABSENT_ANTIRABIQUE],
}


// International Vaccination

export const vaccinationInternational = {
  path: "/vaccine/international-vaccination",
  component: VaccinationInternationalSearch,
  exact:true,
  can: VaccinationManagement.module[VACCINATION].permissions[CREATE][INTERNATIONAL]
}
export const vaccinationInternationalFolder = {
  path: "/vaccine/international-vaccination/:param([0-9]{9})",
  component: VaccinationInternationalFolders,
  can: VaccinationManagement.module[VACCINATION].permissions[VIEW][INTERNATIONAL]
}
export const vaccinationInternationalCreate = {
  path: "/vaccine/international-vaccination/new/:param",
  component: VaccinationInternationalNew,
  can: VaccinationManagement.module[VACCINATION].permissions[CREATE][INTERNATIONAL]
}
export const vaccinationInternationalEdit = {
  path: "/vaccine/international-vaccination/edit/:param",
  component: VaccinationInternationalEdit,
  can: VaccinationManagement.module[VACCINATION].permissions[UPDATE][INTERNATIONAL]
}

// Scolaire Vaccination Routes
export const vaccinationScolaireFolder = {
  path: "/vaccine/scolaire-vaccination/:param?",
  component: VaccinationScolaireFolders,
  anonymous: true,
  exact: true
}
  
const path = routes.admin.path

export default combinePathRoutes({ path }, {
  vaccination,
  vaccinationList,
  vaccinationFolder,
  vaccinationOccationalFolder,
  vaccinationCreate,
  nextvaccination,
  vaccinationOccasionals,
  vaccinationOccationalCreate,
  VaccinationSeasonSearch,
  VaccinationSaisonFolder,
  vaccinationSeasonCreate,
  VaccinationAntirabiesSearch,
  vaccinationAntirabiesFolder,
  vaccinationAntirabiesCreate,
  vaccinationAntirabiesEdit,
  vaccinationAntirabiesView,
  vaccinationAntirabiesKPI,
  vaccinationAntirabiesFirstEdit,
  vaccinationInternational,
  vaccinationInternationalFolder,
  vaccinationInternationalCreate,
  vaccinationInternationalEdit,
  vaccinationScolaireFolder,
  //VaccinationAntirabiesSchemas
  

})
